import { createContext } from 'react';

export const RefreshTokenContext = createContext(null);
